module.exports = __webpack_public_path__ + "img/vessel_visitation_10_63021.a0b69fe1.jpg";